import React from 'react'
import PropTypes from 'prop-types'

import ProjectNoteCommentsListItem from "./ProjectNoteCommentListItem";

const ProjectNoteCommentsList = (props) => {

    return (
        <div className="d-flex flex-column" style={{flex: 1}}>
            {
                props.notes.map((note, index) => <ProjectNoteCommentsListItem key={index} project_id={props.project_id} {...note}/>)
            }
        </div>
    )

}

ProjectNoteCommentsList.propTypes = {
    project_id: PropTypes.string.isRequired
}

export default ProjectNoteCommentsList